<template>
	<div class="row h-100">
		<div class="col-12">
			<div class="card h-100">
				<div class="card-header bg-info text-light">
					Project Checklist
				</div>
				<div class="card-body p-0">
					<div ref="container" class="container-fluid p-0 m-0 h-100 box-sizing-reset"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import fromCDN from 'from-cdn'

export default {
  name: 'ProjChklstApp',
  components: {},
  mounted: function () {
    const self = this

    // this will not wait for css to complete before resolving
    fromCDN([
      // css
      process.env.BASE_URL + 'dhtmlx/suite.min.css',
      process.env.BASE_URL + 'css/common.css',

      // js (libs/utils)
      process.env.BASE_URL + 'dhtmlx/suite.min.js',
      process.env.BASE_URL + 'js/lib/emitter.js',
      process.env.BASE_URL + 'js/lib/papaparse.min.js',
      process.env.BASE_URL + 'js/utils/polyfills.js',
      process.env.BASE_URL + 'js/utils/peiutils.js',
      process.env.BASE_URL + 'js/utils/peiajax.js'
    ])
      .then(_ => fromCDN([ process.env.BASE_URL + 'js/utils/peidhtmlx.js' ])) // this is loaded after because it depends on dhtmlx objects and peiutils
      .then(_ => fromCDN([
        process.env.BASE_URL + 'js/projchklstApp.js'
      ]))
      .then(_ => {
      /* globals _projchklstApp */
        var projchklst = new _projchklstApp(self.$refs.container, process.env.BASE_URL)
        projchklst.init()
      })
  }
}

</script>
<style>
    .navy { background-color: hsl(195, 83%, 16%); }
    .navy_1 { background-color: hsl(195, 83%, 30%); }
    .navy_2 { background-color: hsl(195, 83%, 60%); }
    .navy_final { background-color: hsl(195, 83%, 96%); }
    .navy .dhx_tree-cell, .navy .dhx_grid-cell__content
    ,.navy_1 .dhx_tree-cell, .navy_1 .dhx_grid-cell__content
    ,.navy_2 .dhx_tree-cell, .navy_2 .dhx_grid-cell__content { color:#FFFFFF; }

    .yellow { background-color: hsl(42, 100%, 70%); }
    .yellow_1 { background-color: hsl(42, 100%, 85%); }
    .yellow_2 { background-color: hsl(42, 100%, 95%); }
    .yellow_final { background-color: hsl(42, 100%, 98%); }

    .green { background-color: hsl(164, 95%, 43%); }
    .green_1 { background-color: hsl(164, 95%, 63%); }
    .green_2 { background-color: hsl(164, 95%, 83%); }
    .green_final { background-color: hsl(164, 95%, 96%); }

    .orange { background-color: hsl(14, 90%, 69%); }
    .orange_1 { background-color: hsl(14, 90%, 80%); }
    .orange_2 { background-color: hsl(14, 90%, 91%); }
    .orange_final { background-color: hsl(14, 90%, 96%); }

    .blue { background-color: hsl(195, 83%, 38%); }
    .blue_1 { background-color: hsl(195, 83%, 61%); }
    .blue_2 { background-color: hsl(195, 83%, 83%); }
    .blue_final { background-color: hsl(195, 83%, 94%); }
       .blue .dhx_tree-cell, .blue .dhx_grid-cell__content
      ,.blue_1 .dhx_tree-cell, .blue_1 .dhx_grid-cell__content { color:#ffffff; }

    .red { background-color: hsl(346, 84%, 61%); }
    .red_1 { background-color: hsl(346, 84%, 78%); }
    .red_2 { background-color: hsl(346, 84%, 88%); }
    .red_final { background-color: hsl(346, 84%, 94%); }
       .red .dhx_tree-cell, .red .dhx_grid-cell__content
      ,.red_1 .dhx_tree-cell, .red_1 .dhx_grid-cell__content { color:#ffffff; }

    .hide_nontree_content .dhx_grid-cell:not(:nth-child(1)) {
      border-left: none;
    }
    .hide_nontree_content .dhx_grid-cell:not(:nth-child(1)) > * {
      display: none;
    }

    .hide_grid_header .dhx_header-wrapper {
      display: none;
    }

    .list_item { font-size: 12px; }
    .list_item_header {
      font-weight: bold;
    }
    .list_item_footer {
      float: right;
      font-size: 11px;
      opacity: 0.85;
    }
</style>
